// Module
var code = "<div class=\"color-picker-wrapper\"> <br/> <ChromeColorPicker v-model=\"colorObject\" :disableAlpha=\"true\" style=\"box-shadow:none\"/> <br/> <button @click.stop.prevent=\"acceptColor();\" class=\"color-accent-fill\" style=\"margin:0 20px 20px 50px\" :disabled=\"isColorInitialColor()\"> Apply </button> <br/> </div>";
// Exports
export default code;